const isSubContactId = id => id.includes('sub');

export default isSubContactId;
